import React from 'react';
import "../../Css/Home/HomeAboutProgress.css";
import image from "../../Images/banner/about03.jpg";

import Crafted_for_Daily_Use from "../../Images/Woodsy Advantage/Crafted-for-Daily-Use.webp";
import Smooth_Finish_Every_Time from "../../Images/Woodsy Advantage/Smooth-Finish-Every-Time.webp";
import Sourced_From_Sustainable_Forests from "../../Images/Woodsy Advantage/Sourced-From-Sustainable-Forests.jpg";
import Perfect_for_all_interiors from "../../Images/Woodsy Advantage/Perfect-for-all-interiors.jpeg";
const HomeAboutProgress = () => {
    return (
        <div>
            <section className='home-features-section'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='home-features-section-details-main-con'>
                                <div className='home-feature-section-details-head'>
                                    <h3 className='ttcmsabout-title'>Woodsy Advantage</h3>
                                    <p className='ttcmsabout-desc'>Discover the magic of real wood in every detail and corner.</p>
                                </div>
                                <div className='home-fetaure-section-details-card-main-con'>
                                    <div className='home-fetaure-section-details-card-body'>
                                        <div className='home-fetaure-section-details-card-image-icons'>
                                            <div className='home-fetaure-section-details-card-image'>
                                                <img src={Crafted_for_Daily_Use} alt='Crafted for Daily Use' />
                                            </div>
                                        </div>
                                        <div className='home-fetaure-section-details-card-text'>
                                            <h4>Crafted for Daily Use</h4>
                                            <p>Durable wood made to last through everyday wear beautifully.</p>
                                        </div>

                                    </div>
                                    <div className='home-fetaure-section-details-card-body'>
                                        <div className='home-fetaure-section-details-card-image-icons'>
                                            <div className='home-fetaure-section-details-card-image'>
                                                <img src={Smooth_Finish_Every_Time} alt='Smooth Finish Every Time' />
                                            </div>
                                        </div>
                                        <div className='home-fetaure-section-details-card-text'>
                                            <h4>Smooth Finish Every Time</h4>
                                            <p>Feel the difference with polished, scratch-resistant wood finishes.</p>
                                        </div>

                                    </div>
                                    <div className='home-fetaure-section-details-card-body'>
                                        <div className='home-fetaure-section-details-card-image-icons'>
                                            <div className='home-fetaure-section-details-card-image'>
                                                <img src={Sourced_From_Sustainable_Forests} alt="Sourced From Sustainable Forests" />
                                            </div>
                                        </div>
                                        <div className='home-fetaure-section-details-card-text'>
                                            <h4>Sourced From Sustainable Forests</h4>
                                            <p>Eco-friendly practices ensure responsible and ethical wood sourcing.</p>
                                        </div>
                                    </div>
                                    <div className='home-fetaure-section-details-card-body'>
                                        <div className='home-fetaure-section-details-card-image-icons'>
                                            <div className='home-fetaure-section-details-card-image'>
                                                <img src={Perfect_for_all_interiors} alt='Perfect for all interiors' />
                                            </div>
                                        </div>
                                        <div className='home-fetaure-section-details-card-text'>
                                            <h4>Perfect for all interiors</h4>
                                            <p> It fits well in modern, classic, and rustic decor and is offered by the trusted plywood manufacturer and supplier in Byculla.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-md-6'>
                            <div className='home-features-image-main-con'>
                                <div className='home-features-image-con'>
                                    <img src={image} />
                                    <div class="bgeffect-features"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default HomeAboutProgress
